type IntegerLikeString = string;

/**
 * Returns a function that limits number length.
 * If passed a float, only integer part will be limited.
 *
 * To limit float fraction length, use `limitFloatFractionLengthFactory`
 */
export const limitNumberLengthFactory =
  (limit: number) => (target: IntegerLikeString) => {
    const [int, fraction] = target.split('.');
    const hasSeparator = target.includes('.');

    // limit number length
    let result = (int || '').slice(0, limit);

    // remove leading zeros
    if (int) {
      result = parseInt(result, 10).toString();
    }

    // add fraction back
    if (fraction) {
      result += `.${fraction}`;
    } else if (hasSeparator) {
      result += '.';
    }

    return result;
  };
